module.exports = __webpack_public_path__ + "media/images/countryrect/kg-72b8c7387599c500ceee74f04d209a18.svg";